module.exports = __webpack_public_path__ + "media/images/logo_jata-044f98bc734d24c8a7df181c414a5f74.gif";